const fallbackRandomUUID = () => {
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const bytes = crypto.getRandomValues(new Uint8Array(16));

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
    return [
      hex.slice(0, 4).join(""),
      hex.slice(4, 6).join(""),
      hex.slice(6, 8).join(""),
      hex.slice(8, 10).join(""),
      hex.slice(10, 16).join(""),
    ].join("-");
  }

  return `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const ensureBrowserRandomUUID = () => {
  if (typeof window === "undefined" || typeof window.crypto === "undefined") {
    return;
  }

  if (typeof window.crypto.randomUUID === "function") {
    return;
  }

  Object.defineProperty(window.crypto, "randomUUID", {
    configurable: true,
    writable: true,
    value: fallbackRandomUUID,
  });
};

export const createBrowserSafeId = () => {
  if (typeof crypto !== "undefined") {
    if (typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }

    return fallbackRandomUUID();
  }

  return fallbackRandomUUID();
};
